export default __webpack_public_path__ + "assets/de-DE.0d4cfc7d4ae4088450b208b08fd57b08.svg";